export function getDMPeerMember(channel, currentUserId) {
  if (channel?.channel_type !== 'dm' && !channel?.is_dm) return null;
  const members = channel.members || [];
  return members.find(m => m.user_id !== currentUserId) || null;
}

export function getChannelDisplayName(channel, currentUserId) {
  if (!channel) return '';
  if (channel.channel_type === 'dm' || channel.is_dm) {
    const peer = getDMPeerMember(channel, currentUserId);
    if (peer) return peer.name;
    return channel.name || (channel.members || [])[0]?.name || 'Direct Message';
  }
  return channel.name || '';
}

export function isDirectMessageChannel(channel) {
  return !!(channel && (channel.channel_type === 'dm' || channel.is_dm));
}
